import { Version } from '@angular/core';

export const VERSION = new Version('8.0.0');
